module.exports = __webpack_public_path__ + "img/7.6e3d2c12.jpg";